import { Box, Button, HStack, Icon, Select } from "components/ui";
import { H1, Paragraph, Typography } from "components/ui/Typography";
import { useRouter } from "expo-router";
import { Filter, Grip, List, X } from "lucide-react-native";
import React, { useState } from "react";
import { ItemCategoryRead, ItemSubCategoryRead } from "store/abcoApi";
import MobileFilter from "./MobileFilter";
import SlidePage from "./SlidePage";

type Props = {
	category: ItemCategoryRead;
	subCategory: ItemSubCategoryRead;
	isGridView: boolean;
	itemCount: number;
	setIsGridView: (value: boolean) => void;
	onChange?: (value: any) => void;
	setMobileFilterValues: any;
	mobileFilterValues: any;
};

const ItemFilterListMobile = ({ category, subCategory, setIsGridView, isGridView, itemCount, onChange, setMobileFilterValues, mobileFilterValues }: Props) => {
	const router = useRouter();
	const [isModalVisible, setModalVisible] = useState(false);
	const [currentFilters, setCurrentFilters] = useState(
		mobileFilterValues
			? { ...mobileFilterValues }
			: {
					isCore: false,
					inStock: false,
					isApprovedItem: false,
				},
	);
	const [tempFilters, setTempFilters] = useState(currentFilters);

	const toggleModal = () => {
		if (isModalVisible) {
			// Reset temp filters to current filters when closing without applying
			setTempFilters(currentFilters);
		}
		setModalVisible(!isModalVisible);
	};

	function handleFilterChange(filters: any) {
		setTempFilters(filters);
	}

	function handleApplyFilters() {
		setCurrentFilters(tempFilters);
		// setMobileFilterValues(currentFilters);
		if (onChange) {
			onChange(tempFilters);
		}
		toggleModal();
		setMobileFilterValues(tempFilters);
	}

	function handleClearAll() {
		const clearedFilters = {
			isCore: false,
			inStock: false,
			isApprovedItem: false,
		};
		setTempFilters(clearedFilters);
		setCurrentFilters(clearedFilters);
		setMobileFilterValues(clearedFilters);
		if (onChange) {
			onChange(clearedFilters);
		}
	}

	function onCategoryChange(value: any) {
		if (value != null) {
			router.push(`${category.url}/${value}`);
		}
	}

	function renderCategoryDropdown() {
		if (category == null || category.subCategoryCollection == null || category.subCategoryCollection.length == 0) {
			return;
		}

		const options =
			category.subCategoryCollection?.map((item: ItemSubCategoryRead) => ({
				label: item.name,
				value: item.slug,
			})) || [];

		return (
			<Box paddingBottom={32} zIndex={1}>
				<Select label={category.name ?? ""} onChange={onCategoryChange} options={options} value={{ label: subCategory.name }} />
			</Box>
		);
	}

	return (
		<Box position="relative" zIndex={5} paddingVertical={32} paddingHorizontal={12}>
			<SlidePage
				buttonTitle="Apply"
				buttonAction={handleApplyFilters}
				customHeader={
					<HStack borderBottomWidth={1} paddingVertical={16} borderColor="$neutral100" w={"$full"} alignItems="center" justifyContent="space-between" paddingHorizontal={16}>
						<Button w={"$1/3"} onPress={toggleModal} padding={0}>
							<Icon color="$basicblack" marginRight={"auto"} as={X} />
						</Button>

						<Box w={"$1/3"}>
							<H1
								sx={{
									textAlign: "center",
								}}
							>
								Filter
							</H1>
						</Box>
						<Button w={"$1/3"} onPress={handleClearAll}>
							<Paragraph
								sx={{
									color: "$primarylight",
									textDecorationLine: "underline",
									marginLeft: "auto",
								}}
							>
								Clear all
							</Paragraph>
						</Button>
					</HStack>
				}
				isOpen={isModalVisible}
				toggleModal={toggleModal}
			>
				<MobileFilter toggleModal={toggleModal} onChange={handleFilterChange} initialFilters={tempFilters} />
			</SlidePage>
			{renderCategoryDropdown()}

			<Box w={"$full"}>
				<HStack gap={12}>
					<Button flexDirection="row" flexGrow={1} gap={8} borderWidth={2} paddingHorizontal={16} paddingVertical={8} borderColor="$primarylight" onPress={toggleModal}>
						<Icon color="$primarylight" as={Filter} />
						<Typography
							sx={{
								color: "$primarylight",
								marginRight: "auto",
							}}
							weight="bold"
						>
							Filter ({itemCount}) products
						</Typography>
					</Button>
					<Box gap={12} flexDirection="row">
						<Box>
							<Button
								borderRadius={4}
								gap={8}
								borderWidth={2}
								borderColor="$primarylight"
								paddingHorizontal={16}
								paddingVertical={10}
								backgroundColor={!isGridView ? "transparent" : "$primarylight"}
								style={{ padding: 0, margin: 0 }}
								padding={0}
								p={0}
								onPress={() => setIsGridView(true)}
							>
								<Icon color={isGridView ? "$basicwhite" : "$primarylight"} as={Grip} />
							</Button>
						</Box>
						<Box>
							<Button
								borderWidth={2}
								borderColor="$primarylight"
								backgroundColor={isGridView ? "transparent" : "$primarylight"}
								paddingHorizontal={16}
								borderRadius={4}
								paddingVertical={10}
								padding={0}
								p={0}
								onPress={() => setIsGridView(false)}
							>
								<Icon fontSize={42} as={List} color={!isGridView ? "$basicwhite" : "$primarylight"} />
							</Button>
						</Box>
					</Box>
				</HStack>
			</Box>
		</Box>
	);
};

export default ItemFilterListMobile;
